/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Row,
  Col,
  Button,
  Select,
  Spin,
  Icon,
  message,
  Modal,
  Input,
  DatePicker,
  Pagination,
  Tooltip
} from 'antd';
import moment from 'moment';
import Cookies from 'universal-cookie';

import { APIs } from '../utils/apis';
import { csvDownload } from '../utils/assetUtils';

const { Option } = Select;
const { RangePicker } = DatePicker;
const { TextArea } = Input;

const cookies = new Cookies();

const columns = [
  {
    title: 'Enteprise',
    key: 'enterprise',
    width: 8.33
  },
  {
    title: 'Module',
    key: 'module',
    width: 8.33
  },
  {
    title: 'Feature',
    key: 'feature',
    width: 8.33
  },
  {
    title: 'Requested By',
    key: 'requestedBy',
    width: 8.33
  },
  {
    title: 'User Type',
    key: 'userType',
    width: 8.33
  },
  {
    title: 'Name',
    key: 'name',
    width: 8.33
  },
  {
    title: 'Phone',
    key: 'phone',
    width: 8.33
  },
  {
    title: 'Request Date',
    key: 'requestDate',
    width: 8.33
  },
  {
    title: 'Acknowledged By',
    key: 'acknowledgedBy',
    width: 8.33
  },
  {
    title: 'Acknowledged Date',
    key: 'acknowledgedDate',
    width: 8.33
  },
  {
    title: 'Acknowledgement Reason',
    key: 'acknowledgeReason',
    width: 8.33
  },
  {
    title: 'Closed By',
    key: 'closedBy',
    width: 8.33
  },
  {
    title: 'Closed Date',
    key: 'closedDate',
    width: 8.33
  },
  {
    title: 'Closed Reason',
    key: 'closedReason',
    width: 8.33
  }
];

// export const featuresList = [
//   {
//     label: 'BRAND EXPERIENCE',
//     value: 'BRAND_EXPERIENCE'
//   }
// ];

// export const modulesList = [
//   {
//     label: 'NPS',
//     value: 'NPS'
//   }
// ];

export const statusesList = [
  { label: 'Closed', value: 'closed' },
  { label: 'Acknowledged', value: 'acknowledged' },
  { label: 'All', value: 'all' }
];

export const featuresList = [
  { label: 'BRAND_EXPERIENCE', value: 'BRAND_EXPERIENCE' },
  {
    label: 'Post Delivery Survey Notification',
    value: 'Post Delivery Survey Notification'
  },
  { label: 'All', value: 'all' }
];

const dateKeys = ['acknowedgedDate', 'requestDate', 'closedDate'];

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

const FeatureRequests = () => {
  const [state, setState] = useState({
    requests: [],
    isFetching: true,
    module: '',
    feature: '',
    options: [],
    showModal: false,
    type: '',
    editingRequest: {},
    inputValue: '',
    enterpriseList: [],
    user: cookies.get('name')
  });

  const [filters, setFilters] = useState({
    feature: 'all',
    module: 'all',
    acknowledgedDate: [],
    closedDate: [],
    requestDate: [moment().subtract(7, 'days'), moment()],
    status: 'all',
    enterprise: ''
  });

  const [page, setPage] = useState(1);
  const pageSize = 50; // for now hard coding to 50 per items per page

  const fetchData = () => {
    axios({
      url: `${APIs.FIREBASE.GET}/?feature=${filters.feature}&module=${
        filters.module
      }&ackStartDate=${+new Date(
        filters.acknowledgedDate[0]
      )}&ackEndDate=${+new Date(
        filters.acknowledgedDate[1]
      )}&closedStartDate=${+new Date(
        filters.closedDate[0]
      )}&closedEndDate=${+new Date(
        filters.closedDate[1]
      )}&requestStartDate=${+new Date(
        filters.requestDate[0]
      )}&requestEndDate=${+new Date(filters.requestDate[1])}&enterprise=${
        filters.enterprise
      }&status=${filters.status}`,
      method: 'GET'
    })
      .then(res => {
        if (res?.data?.meta?.status === 200 && res?.data?.result) {
          state.requests = res.data.result.sort(
            (a, b) => moment(b.requestedAt) - moment(a.requestedAt)
          );
        } else {
          message.error('Unable to fetch data from Firebase');
        }
        setState({ ...state });
        handleCancel();
      })
      .catch(error =>
        message.error('Unable to fetch data from Firebase' + error)
      );
  };

  const showModal = (e, editingRequest, type) => {
    setState({ ...state, showModal: true, editingRequest, type });
  };

  const handleCancel = () => {
    setState({
      ...state,
      showModal: false,
      editingRequest: '',
      type: '',
      inputValue: '',
      isFetching: false
    });
  };

  const onChange = e => {
    const { name, value } = e.target;
    setState({
      ...state,
      [name]: value
    });
  };

  const onSubmit = e => {
    setState({ ...state, isFetching: true });
    e.preventDefault();
    const todayDate = new Date().toString();
    const dataToUpdate = {};
    if (state.type === 'acknowledge') {
      dataToUpdate.acknowledgedBy = state.user;
      dataToUpdate.acknowledgedDate = todayDate;
      dataToUpdate.acknowledgedReason = state.inputValue;
    } else {
      dataToUpdate.closedBy = state.user;
      dataToUpdate.closedDate = todayDate;
      dataToUpdate.closedReason = state.inputValue;
    }
    const data = {
      ...state.editingRequest,
      ...dataToUpdate
    };

    axios({
      url: `${APIs.FIREBASE.GET}`,
      method: 'POST',
      data
    })
      .then(res => {
        if (res?.data?.meta?.status === 200 && res?.data?.result) {
          message.success('Successfully updated request');
          fetchData();
        } else {
          message.error('Unable to fetch data from Firebase');
        }
        setState({ ...state, isFetching: false });
      })
      .catch(error =>
        message.error('Unable to fetch data from Firebase. ' + error)
      );
  };

  const handleChange = (key, value) => {
    setFilters({ ...filters, [key]: value });
  };

  const onDateChage = (dateString, name) => {
    const resetKeys = JSON.parse(JSON.stringify(dateKeys)).filter(
      key => key !== name
    );
    setFilters({
      ...filters,
      [name]: dateString,
      [resetKeys[0]]: [],
      [resetKeys[1]]: []
    });
  };

  const disabledDate = current => {
    // Cannot select days future dates
    return current && current > moment().endOf('day');
  };

  const itemRender = (current, type, originalElement) => {
    if (type === 'prev') {
      return <a>Previous</a>;
    }
    if (type === 'next') {
      return <a>Next</a>;
    }
    return originalElement;
  };

  const onPageChange = page => {
    setPage(page);
  };

  const downloadAsCSV = () => {
    const header = [
      'Enterprise',
      'Module',
      'Feature',
      'Requested By',
      'User Type',
      'Request Date',
      'Acknowledged By',
      'Acknowledged Date',
      'Acknowledgement Reason',
      'Closed By',
      'Closed Date',
      'Closed Reason'
    ];
    const rows = [];
    state.requests.forEach(request => {
      rows.push([
        request.enterprise,
        request.module,
        request.feature,
        request.userName,
        request.profileType,
        moment(request.requestedAt).format('Do MMM YYYY h:mm a'),
        request.acknowledgedBy,
        request.acknowledgedDate,
        request.acknowledgedReason,
        request.closedBy,
        request.closedDate,
        request.closedReason
      ]);
    });
    csvDownload({
      header,
      rows,
      name: Number(new Date().getTime() / 1000).toString()
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <Row
        className="margin-bottom-10 view-header"
        type="flex"
        justify="center"
        align="bottom"
      >
        <Col span={3}>
          <div className="global-search-wrapper" style={{ width: '96%' }}>
            <p>Feature</p>
            <Select
              showSearch
              style={{ width: '96%' }}
              placeholder="Select Feature"
              optionFilterProp="children"
              value={filters.feature ?? undefined}
              onChange={value => handleChange('feature', value)}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              disabled={
                filters.closedDate.length > 0 ||
                filters.acknowledgedDate.length > 0 ||
                filters.requestDate.length > 0 ||
                filters.status !== 'all'
              }
            >
              {featuresList.map(feature => (
                <Option key={feature.value} value={feature.value}>
                  {feature.label}
                </Option>
              ))}
            </Select>
          </div>
        </Col>
        <Col span={3}>
          <div className="global-search-wrapper" style={{ width: '96%' }}>
            <p>Status</p>
            <Select
              showSearch
              style={{ width: '96%' }}
              placeholder="Select Status"
              optionFilterProp="children"
              value={filters.status ?? undefined}
              onChange={value => handleChange('status', value)}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              disabled={
                filters.closedDate.length > 0 ||
                filters.acknowledgedDate.length > 0 ||
                filters.requestDate.length > 0 ||
                filters.feature !== 'all'
              }
            >
              {statusesList.map(status => (
                <Option key={status.value} value={status.value}>
                  {status.label}
                </Option>
              ))}
            </Select>
          </div>
        </Col>
        <Col span={5}>
          <div className="global-search-wrapper" style={{ width: '96%' }}>
            <p>Request Date</p>
            <RangePicker
              onChange={value => onDateChage(value, 'requestDate')}
              allowClear
              value={filters.requestDate ?? undefined}
              disabled={
                filters.closedDate.length > 0 ||
                filters.acknowledgedDate.length > 0 ||
                filters.status !== 'all' ||
                filters.feature !== 'all'
              }
              disabledDate={disabledDate}
            />
          </div>
        </Col>
        <Col span={5}>
          <div className="global-search-wrapper" style={{ width: '96%' }}>
            <p>Closed Date</p>
            <RangePicker
              onChange={value => onDateChage(value, 'closedDate')}
              allowClear
              value={filters.closedDate ?? undefined}
              disabled={
                filters.requestDate.length > 0 ||
                filters.acknowledgedDate.length > 0 ||
                filters.status !== 'all' ||
                filters.feature !== 'all'
              }
              disabledDate={disabledDate}
            />
          </div>
        </Col>
        <Col span={5}>
          <div className="global-search-wrapper" style={{ width: '96%' }}>
            <p>Acknowledged Date</p>
            <RangePicker
              onChange={value => onDateChage(value, 'acknowledgedDate')}
              allowClear
              value={filters.acknowledgedDate ?? undefined}
              disabled={
                filters.closedDate.length > 0 ||
                filters.requestDate.length > 0 ||
                filters.status !== 'all' ||
                filters.feature !== 'all'
              }
              disabledDate={disabledDate}
            />
          </div>
        </Col>
        <Col span={2} className="text-right">
          <Button type="primary" onClick={fetchData}>
            Submit
          </Button>
        </Col>
      </Row>
      <Row>
        <Col
          span={24}
          className="d-flex justify-content-between align-items-center margin-bottom-10"
        >
          <p>
            Note: Only one filter can be active at any time due to firebase db
            query restrictions. To clear a date filter hover over the calendar
            icon of the respective date filter
          </p>
          <Button
            type="ghost"
            onClick={downloadAsCSV}
            disabled={state.requests.length === 0}
          >
            Download as CSV
          </Button>
        </Col>
      </Row>
      <Row>
        <Col span={24} className="margin-bottom-10">
          {state.isFetching ? (
            <Spin indicator={antIcon} />
          ) : (
            <>
              {state.requests.length <= 0 ? (
                <div>&nbsp; No Data</div>
              ) : (
                <div style={{ overflow: 'auto' }}>
                  <table
                    className={`ant-table ant-table-small w-1600 table-responsive`}
                  >
                    <thead className="ant-table-thead">
                      <tr>
                        {columns.map((item, i) => (
                          <th
                            className="padding-8"
                            key={i}
                            width={`${item.width}%`}
                          >
                            {item.title}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody className="ant-table-tbody">
                      {state.requests
                        .slice(
                          (page - 1) * pageSize,
                          (page - 1) * pageSize + pageSize
                        )
                        .map((request, i) => (
                          <tr key={i}>
                            <td className="padding-8">
                              <span>{request.enterprise}</span>
                            </td>
                            <td className="padding-8">{request.module}</td>
                            <td className="padding-8">{request.feature}</td>
                            <td className="padding-8">{request.userName}</td>
                            <td className="padding-8">{request.profileType}</td>
                            <td className="padding-8">{request.name}</td>
                            <td className="padding-8">{request.phone}</td>
                            <td className="padding-8">
                              {moment(request.requestedAt).format(
                                'Do MMM YYYY, h:mm a'
                              )}
                            </td>
                            <td className="padding-8">
                              {request.acknowledgedBy ? (
                                request.acknowledgedBy
                              ) : (
                                <Button
                                  type="primary"
                                  size="small"
                                  onClick={e =>
                                    showModal(e, request, 'acknowledge')
                                  }
                                >
                                  Acknowledge
                                </Button>
                              )}
                            </td>
                            <td className="padding-8">
                              {request.acknowledgedDate
                                ? moment(request.acknowledgedDate).format(
                                    'Do MMM YYYY, h:mm a'
                                  )
                                : ''}
                            </td>
                            <td className="padding-8">
                              <Tooltip title={request.acknowledgedReason}>
                                <span>
                                  {request.acknowledgedReason.slice(0, 20)}
                                </span>
                              </Tooltip>
                              {request.acknowledgedReason.length > 21
                                ? '...'
                                : ''}
                            </td>
                            <td className="padding-8">
                              {request.closedBy ? (
                                request.closedBy
                              ) : request.acknowledgedBy ? (
                                <Button
                                  type="primary"
                                  size="small"
                                  onClick={e => showModal(e, request, 'close')}
                                >
                                  Close
                                </Button>
                              ) : null}
                            </td>
                            <td className="padding-8">
                              {request.closedDate
                                ? moment(request.closedDate).format(
                                    'Do MMM YYYY, h:mm a'
                                  )
                                : ''}
                            </td>
                            <td className="padding-8">
                              <Tooltip title={request.closedReason}>
                                <span>{request.closedReason.slice(0, 20)}</span>
                              </Tooltip>
                              {request.closedReason.length > 21 ? '...' : ''}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              )}
            </>
          )}
        </Col>
      </Row>
      <Row>
        <Col>
          <p>{pageSize} per page</p>
          <Pagination
            total={state.requests.length}
            itemRender={itemRender}
            showTotal={(total, range) =>
              `${range[0]}-${range[1]} of ${total} items`
            }
            pageSize={pageSize}
            onChange={onPageChange}
            current={page}
          />
        </Col>
      </Row>
      <Modal
        title="Remarks"
        visible={state.showModal}
        onOk={onSubmit}
        onCancel={handleCancel}
      >
        <>
          <p>
            Reason to <u>{state.type}</u> request raised by{' '}
            <strong>{state.editingRequest.enterprise}</strong> & user{' '}
            <strong>{state.editingRequest.userName}</strong>
          </p>
          <TextArea
            name="inputValue"
            placeholder={`Enter a reason`}
            className="ant-input"
            value={state.inputValue}
            onChange={onChange}
            rows={3}
          />
        </>
      </Modal>
    </div>
  );
};

export default FeatureRequests;
